<template>
	<div>
		<div class="row filter-bar-desktop d-none d-md-flex mb-4">
			<div class="col">
				{{ num_products }} produkter
			</div>

			<div class="col d-flex align-items-center justify-content-end">

				<div class="me-2">
				Sortera efter:
				</div>

				<div class="dropdown-wrapper">
					<button class="btn select-dropdown" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
						{{ active.text }}
					</button>
					<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
						<li class="dropdown-item" v-for="option in options" @click="active = option">{{ option.text }}</li>
					</ul>
				</div>

			</div>
		</div>

		<div class="filter-bar-mobile">
			<div class="sort" data-bs-toggle="modal" data-bs-target="#sortModal">
				{{ active.text }}
			</div>

			<div class="modal fade" id="sortModal" tabindex="-1" aria-labelledby="sortModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-fullscreen">
					<div class="modal-content">
						<div class="modal-header justify-content-between">
							<button type="button" class="btn-close btn-close-left" data-bs-dismiss="modal" aria-label="Close"></button>
							<h5 class="modal-title" id="sortModalLabel">Sortera efter</h5>
							<button type="button" class="btn-close btn-close-right invisible" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="option" v-for="option in options" @click="active = option">{{ option.text }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<p class="fs-5 fw-light text-center d-md-none mb-5">Visar {{ num_products }} produkter</p>
	</div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
	props: {
		num_products: {
			required: true
		},
		term_id: {
			required: true
		}
	},

	data() {
		return {
			active: null,
			options: [
				{ type: 'default', text: 'Standardsortering' },
				{ type: 'num_units_sold_desc', text: 'Mest sålda' },
				{ type: 'newest', text: 'Nyaste' },
				{ type: 'price_asc', text: 'Lägsta pris' },
				{ type: 'price_desc', text: 'Högsta pris' },
			],
		}
	},

	created ()  {
		this.active = this.options[0]
	},

	watch: {
		active () {
			this.sort()
		}
	},

	methods: {
		sort() {
			const ajaxUrl = window.ajax_url


			axios({
				method: 'post',
				url: ajaxUrl + '?action=mg_product_sort',
				data: qs.stringify({ sortBy: this.active.type, term_id: this.term_id })
			})
				.then((response) => {
					console.log('mg_product_sort result')
					console.log(response.data)

					if (response.data.status === 'ok') {
						console.log('hide modal pls')
						//$('body').trigger('added_to_cart', [response.data.cart_count])

						const myModalEl = document.getElementsByClassName('btn-close');
						myModalEl[0].click()

						$('#productsContainer').html(response.data.html)
					}
				})
				.catch((error) => {
					console.log('error')
					console.log(error)
					if (error.response && error.response.data) {
						// errorMsg = error.response.data.message
					}
				})
		}
	}
}
</script>
